import {observer} from "mobx-react";
import {LayoutContentPromptManagement, LayoutPagePromptManagement} from "../components";
import {usePromptManagementStore} from "../hooks";
import React, {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import {PromptManagementSystemPagesTypes} from "../types";
import {useStore} from "../../../../hooks";
import Spinner from "../../../../components/common/Spinner";

export const PromptManagementDetail = observer(() => {
  const { authStore } = useStore();
  const store = usePromptManagementStore();
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentPrompt, isLoading, error } = store;

  useEffect(() => {
    if (!id) {
      navigate("/v2/prompt-management-system");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  useEffect(() => {
    if (id) {
      store.onChangePage(authStore.currentWorkspaceUuid, PromptManagementSystemPagesTypes.PAGE_EDIT, id);
      store.getAgents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  useEffect(() => {
    if (error.type && error.type === "prompt_not_found") {
      navigate("/v2/prompt-management-system");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error.type]);
  
  return (
    <>
      {isLoading && (<Spinner dataTestId="spinner" />)}
      {!isLoading && currentPrompt && (
        <LayoutPagePromptManagement title="Provide a Clear and Descriptive Prompt">
          <LayoutContentPromptManagement />
        </LayoutPagePromptManagement>
      )}
    </>
  );
});
